export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "Spreadsheet",
  language: "Langue",
  nav: {
    spreadsheet: "Spreadsheet",
    categories: "Catégories",
    reviews: "Avis",
    shipping: "Livraison",
    qc: "QC",
    safety: "Sécurité",
    guides: "Guides",
    home: "Accueil",
    shoppingGuide: "Guide d'achat",
    mobileCategories: "Parcourir les catégories",
  },
  cta: {
    explore: "Explorer le Spreadsheet AllChinaBuy",
    visitMain: "Visiter le site principal",
    buyNow: "Acheter maintenant",
    viewAll: "Voir toutes les catégories",
    readGuide: "Lire le guide",
    readArticle: "Lire le guide complet",
    backHome: "Retour à l'accueil",
  },
  trust:
    "Ressource d'information indépendante • Mise à jour régulièrement • Anglais, français, danois et allemand",
  categoryNames: {
    shoes: "Chaussures",
    hoodies: "Hoodies/Sweats",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons/Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
  footer: {
    disclaimer:
      "Ceci est une ressource d'information indépendante, sans affiliation ni parrainage par AllChinaBuy. Les liens de produits mènent à notre site principal.",
    rights: "Tous droits réservés.",
    quickLinks: "Liens rapides",
    categories: "Catégories",
    resources: "Ressources",
    about: "À propos de ce site",
    aboutText:
      "Un hub de ressources multilingue pour organiser vos trouvailles de produits, vendeurs et références d'achat AllChinaBuy.",
  },
};